(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["Kaiross-entrega"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__keeLoaded) return;
    window.__keeLoaded = true;

    var DAYS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    var DAY_MS = 86400000;

    function bogotaNow() {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Bogota',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date());
      var p = {};
      parts.forEach(function (x) { p[x.type] = x.value; });
      return {
        date: Date.UTC(+p.year, +p.month - 1, +p.day),
        hour: +p.hour
      };
    }

    function iso(ms) {
      var d = new Date(ms);
      return d.getUTCFullYear() + '-' +
        String(d.getUTCMonth() + 1).padStart(2, '0') + '-' +
        String(d.getUTCDate()).padStart(2, '0');
    }

    function fmt(ms) {
      var d = new Date(ms);
      return DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()];
    }

    function init(root) {
      var shipDays = parseInt(root.dataset.shipDays, 10) || 0;
      var deliveryDays = parseInt(root.dataset.deliveryDays, 10) || 1;
      var cutoff = parseInt(root.dataset.cutoff, 10);
      if (isNaN(cutoff)) cutoff = 15;
      var skipSat = root.dataset.skipSat === 'true';
      var holidays = {};
      (root.dataset.holidays || '').split(',').forEach(function (h) {
        h = h.trim();
        if (h) holidays[h] = true;
      });

      function isBiz(ms) {
        var wd = new Date(ms).getUTCDay();
        if (wd === 0) return false;
        if (skipSat && wd === 6) return false;
        return !holidays[iso(ms)];
      }
      function nextBiz(ms) {
        do { ms += DAY_MS; } while (!isBiz(ms));
        return ms;
      }

      var now = bogotaNow();
      var ship = now.date;
      if (now.hour >= cutoff || !isBiz(ship)) ship = nextBiz(ship);
      for (var i = 0; i < shipDays; i++) ship = nextBiz(ship);
      var arrive = ship;
      for (var j = 0; j < deliveryDays; j++) arrive = nextBiz(arrive);

      root.querySelector('[data-kee-buy]').textContent = fmt(now.date);
      root.querySelector('[data-kee-ship]').textContent = fmt(ship);
      root.querySelector('[data-kee-arrive]').textContent = fmt(arrive);
      root.querySelector('[data-kee-ship-label]').textContent =
        ship === now.date ? root.dataset.labelToday : root.dataset.labelLater;
      root.setAttribute('data-kee-ready', '1');
    }

    function run() {
      document.querySelectorAll('[data-kee]:not([data-kee-ready])').forEach(init);
    }

    // Cubre cambios de variante y el editor: Shopify vuelve a pintar el bloque
    // y hay que calcular las fechas otra vez.
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        run();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
